import React from "react";
import "./GamificationScoreBoard.css";
import fallbackAvatar from "../../assets/images/c1.png";

const previewPlayers = [
  { user_id: 1, user_name: "Ms. Navjot Kaur", total_points: "0" },
  { user_id: 2, user_name: "Ms. Myra Verma", total_points: "0" },
  { user_id: 3, user_name: "Ms. Kritika Agarwal", total_points: "0" },
  { user_id: 4, user_name: "Mr. Shaurya Singh", total_points: "0" },
];

const GamificationScoreBoard = ({ players = previewPlayers }) => (
  <div className="scoreBoardWrapper">
    <div className="scoreBoard">
      <div className="scoreBoardHeader">
        <div className="scoreBoardLine" />
        <h2 className="scoreBoardTitle">Score Board</h2>
        <div className="scoreBoardLine" />
      </div>
      <div className="scoreBoardList">
        {players.length === 0 ? (
          <p className="scoreBoardEmpty">Scores will appear when players join.</p>
        ) : players.map((player, index) => (
          <div className="scoreBoardPlayer" key={player.user_id || player.id || index}>
            <div className="scoreBoardRank">{index + 1}</div>
            <div className="scoreBoardAvatar">
              <img src={player.profile_pics || player.image || fallbackAvatar} alt="" />
            </div>
            <div className="scoreBoardPlayerName">
              {player.user_name || player.name || "Player"}
            </div>
            <div className="scoreBoardPoints">
              Point: {player.total_points ?? player.points ?? 0}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default GamificationScoreBoard;
